import React, { memo } from "react";
import { Handle, Position } from "react-flow-renderer";
import { Instagram, ArrowForwardIos } from "@mui/icons-material";

export default memo(({ data, isConnectable }) => (
  <div style={{
    width: 300,
    padding: 16,
    borderRadius: 14,
    background: "#FFFFFF",
    border: "1px solid #EAEBF2",
    boxShadow: "0 10px 28px rgba(26,31,54,.10)",
  }}>
    <Handle type="target" position={Position.Left} id="in" isConnectable={isConnectable}
      style={{ width: 12, height: 12, background: "#4450FF" }} />
    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#24202a", fontWeight: 700 }}>
      <span style={{ width: 36, height: 36, borderRadius: 10, display: "grid", placeItems: "center", background: "#FCEAF3" }}>
        <Instagram style={{ color: "#D62976", fontSize: 20 }} />
      </span>
      {data.label || "Início do Instagram"}
    </div>
    <div style={{ marginTop: 10, color: "#73768A", fontSize: 12, lineHeight: 1.45 }}>
      {data.description || "Gatilho do Instagram configurado"}
    </div>
    <Handle type="source" position={Position.Right} id="a" isConnectable={isConnectable}
      style={{ width: 18, height: 18, right: -10, background: "#4450FF" }}>
      <ArrowForwardIos style={{ color: "white", width: 10, height: 10, marginLeft: 3 }} />
    </Handle>
  </div>
));
